import { fromJS } from 'immutable'
import * as types from './action-types'

const InitialState = fromJS({
  idle: false,
  // For altering UI for video or image 
  mediaType: 'image'
})

export default (state = InitialState, action) => {
    switch (action.type) {
      case types.LIGHTBOX_IDLE:
        return state.set('idle', action.payload)

      case types.LIGHTBOX_MEDIA_TYPE:
        return state.set('mediaType', action.payload)

      default:
        return state
    }
}



// WEBPACK FOOTER //
// ./src/components/lightbox-container/reducer.js